import DataTypeModel from '../../../../models/DataType'
import apiUrl from '../../../Url/ApiUrl'
import { get, post } from '../../../methods'

// Xtrf
export const getXtrfProjects = (parameters, cancelToken) =>
    post(apiUrl.projects.xtrfProjectsList, DataTypeModel(parameters), cancelToken)

export const getFeedbackQuestions = (uriParams) =>
    get(apiUrl.projects.xtrfFeedbackQuestion, DataTypeModel({}, uriParams))

export const getProjectFeedbackAnswers = (uriParams) =>
    get(apiUrl.projects.xtrfProjectFeedbackAnswers, DataTypeModel({}, uriParams))

export const postProjectFeedbackAnswers = (data) =>
    post(apiUrl.projects.xtrfProjectsPostFeedbackAnswers, DataTypeModel(data.bodyRequest, data.uriParams))

export const getXtrfProjectTasks = (uriParams) => get(apiUrl.projects.xtrfProjectTasks, DataTypeModel({}, uriParams))

export const getXtrfProject = (uriParams) => get(apiUrl.projects.xtrfProject, DataTypeModel({}, uriParams))

export const getXtrfProjectFiles = (uriParams) => get(apiUrl.projects.xtrfProjectFiles, DataTypeModel({}, uriParams))

export const downloadXtrfProjectFileUrl = (uriParams) =>
    get(apiUrl.projects.xtrfProjectFile, DataTypeModel({}, uriParams))

export const postXtrfProjectFile = (file) => post(apiUrl.projects.xtrfPostFile, DataTypeModel(file))

export const downloadXtrfPdfProjectUrl = (uriParams) =>
    get(apiUrl.projects.xtrfProjectdownloadPdf, DataTypeModel({}, uriParams))
